import { useRouteQuery } from '@/common/route/useRouteQuery';
import { pageSize } from '@/common/utils/helpers';
import { StringUtils } from '@/common/utils/stringUtils';
import { useBaseListView } from '@/common/view/useBaseListView';
import { creditService } from '@/services/credit';
import { rubyService } from '@/services/ruby';
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { TransactionType } from './mixins';

export function useAccountTransaction() {
    const route = useRoute();

    const { query, updateQueryToRoute } = useRouteQuery({
        definition: {
            type: { type: 'number', default: TransactionType.Credit },
            offset: { type: 'number', default: 0 },
            limit: { type: 'number', default: pageSize }
        },
        onChange: () => fetchList()
    });

    const accountId = StringUtils.toNumber(route.params.accountId.toString());
    const transactionColumnByType = computed(() => {
        switch (query.type) {
            case TransactionType.Credit:
                return { label: 'Credit', field: 'credit', title: 'Credit' };
            case TransactionType.Payment:
                return { label: 'Credit', field: 'credit', title: 'Payment' };
            case TransactionType.Ruby:
                return { label: 'Ruby', field: 'ruby', title: 'Ruby' };
            default:
                return { label: '', field: '', title: '' };
        }
    });

    const request = (params: any) => {
        if (query.type === TransactionType.Credit) {
            return creditService.transaction.list(params);
        } else if (query.type === TransactionType.Payment) {
            return creditService.transaction.listPayment(params);
        } else if (query.type === TransactionType.Ruby) {
            return rubyService.transaction.list(params);
        }

        return Promise.resolve({ code: 0, data: null }); // default promise
    };

    const { list, total, fetchList } = useBaseListView({
        request: request,
        paramsBuilder: () => ({ ...query, accountId }),
        hooks: {
            onPageChange: offset => (query.offset = offset),
            canFetch: () => query.type != null,
            onSuccess: updateQueryToRoute
        }
    });

    return { accountId, list, total, fetchList, query, transactionColumnByType };
}
